<template>
  <div class="positions">
    <bim-text type=h5 bold class="text-center mb-10">Вот что мы нашли</bim-text>
    <BlockTopPositions :positions="positions" class="mb-9" />
    <BlockFullPositions @downloadFull="$emit('downloadFull')" :positions="positions" />
    <div class="positions__wrapper positions__wrapper--background-gray d-flex mt-9">
      <img class="positions__image" alt="" :src="img_catalog + 's-6.svg'" />
      <div class="d-flex flex-column justify-center">
        <bim-text type=accent class="mb-10">Скачать пример отчета из 5 позиций</bim-text>
        <div>
          <bim-button @click="$emit('downloadExample')" size=l label="Скачать" color=gray />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlockFullPositions from "./BlockFullPositions"
import BlockTopPositions from "./BlockTopPositions"
const img_catalog = "/dist/assets/front_white/img/landing_estimate/"
export default {
  name: "SlideFoundPositions",
  props: {
    positions: Object,
  },
  components: {
    BlockFullPositions,
    BlockTopPositions,
  },
  data() {
    return {
      img_catalog,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
.text-center {
  text-align: center;
}
.positions {
  .positions__wrapper {
    width: 683px;
  }
  .positions__wrapper--border {
    border: 2px dashed $primary-color;
  }
  .positions__wrapper--background-gray {
    background: #fafafa;
  }
  .positions__image {
    margin: 63px 53px;
  }
}
</style>